module.exports = __webpack_public_path__ + "img/img-banner-business-presents.0ba884d5.png";